import { OBRASOCIAL_SUCCESS, OBRASOCIAL_LOADING, OBRASOCIAL_ERROR } from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

export const obraSocial = () => (dispatch) => {
  dispatch({
    type: OBRASOCIAL_LOADING,
  });

 axiosLogin().then(respuesta => {
  respuesta
  .get(`/shared/obras-sociales`)
  .then((res) => {
    dispatch({
      type: OBRASOCIAL_SUCCESS,
      payload: res.data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
    };

    dispatch({
      type: OBRASOCIAL_ERROR,
      payload: error,
    });
  });
 } )
};

// export const obraSocial = () => (dispatch) => {
//   dispatch({
//     type: OBRASOCIAL_LOADING,
//   });

//  axiosInstance().then(respuesta => {
//   respuesta
//   .get(`/registro/obra_sociales`)
//   .then((res) => {
//     dispatch({
//       type: OBRASOCIAL_SUCCESS,
//       payload: res.data,
//     });
//   })
//   .catch((err) => {
//     let error = {
//       detail: err.response
//         ? err.response.data
//         : "Error al contactar el server.",
//     };

//     dispatch({
//       type: OBRASOCIAL_ERROR,
//       payload: error,
//     });
//   });
//  } )
// };